import { PolicyTermSearchRequestQuery, PolicyTermSearchResponse } from '@lio/api-types';
import { policyTermQueryKey, getPolicyTermQuery } from '@services/policyTerm';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useSearchPolicyTerms = ({
  policyId,
  queryParams,
}: {
  policyId: string;
  queryParams: PolicyTermSearchRequestQuery;
}) => {
  const client = useClient();
  const query = getPolicyTermQuery(queryParams);
  const result = useQuery({
    queryKey: policyTermQueryKey.searchWithParams(policyId, queryParams),
    queryFn: () =>
      client
        .get(`policy/${policyId}/policy-term?${query}&sort=-effectiveOn,-createdAt`)
        .json<PolicyTermSearchResponse>(),
    refetchOnWindowFocus: false,
  });
  return { ...result, policyTerms: result.data };
};
